import React, { Component } from 'react';
import $ from 'jquery';
import '../Admin/viewAdmin.css';
import Axios from 'axios';
import config from '../../config/config';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as getAllAdminActions from '../../Actions/getAllAdmin';
import setAllAdminReducer from '../../Reducers/setAllAdminReducer';
import * as CampusActions from '../../Actions/Campus';
import * as sharedActions from '../../Actions/sharedActions';
import setCampusReducer from '../../Reducers/setCampusReducer';
import SnackBar from '../../components/SnackBar/SnackBar';

class ViewManager extends Component {
	constructor(props) {
		super(props);
		this.state = {
			campusAllData: [],
			post: '',
			staffId: '',
			campusAllData: [],
			department: [],
			postData: [],
			staff: [],
			adminData: [],
			modalData: null,
			name: '',
			userName: '',
			password: '',
			post: '',
			enabled: false,
			id: null,
			isLoading: true,
			disablepage: false,
			disableBPage: true,
			currentPage: 1,
			todosPerPage: 10,
			pageCounter: 10,
			msg: '',
			loading: true
		};
	}

	handleClickNextFrwd = () => {
		const { adminData, todosPerPage, count, currentPage } = this.state;
		let pageNumbers = [];
		for (
			let i = 1;
			i <= Math.ceil(adminData.length / this.state.todosPerPage);
			i++
		) {
			pageNumbers.push(i);
		}

		console.log('pagelength: ', pageNumbers.length);
		console.log('current page: ', currentPage);
		if (currentPage === pageNumbers.length) {
			this.setState({
				disablepage: true
			});
		} else {
			this.setState(prevState => ({
				currentPage: prevState.currentPage + 1,
				disableBPage: false
			}));
		}
	};
	handleClickNextBack = () => {
		const { adminData, todosPerPage, count, currentPage } = this.state;
		console.log('current page: ', currentPage);
		if (currentPage === 1) {
			this.setState({
				disableBPage: true,
				disablepage: false
			});
		} else {
			this.setState(prevState => ({
				currentPage: prevState.currentPage - 1
			}));
			this.setState({
				disablepage: false
			});
		}
	};
	handleClickNext = event => {
		this.setState({
			currentPage: Number(event.target.id),
			disablepage: false,
			disableBPage: false
		});
	};

	componentDidUpdate() {
		$('[data-toggle="tooltip"]').tooltip();
	}
	componentDidMount() {
		$(document).ready(function() {
			$('[data-toggle="tooltip"]').tooltip();
		});
		this.props.sharedActions
			.getDataWithoutDispatch('/api/Managers')
			.then(success => {
				this.setState({
					adminData: success,
					isLoading: false,
					loading: false
				});
			})
			.catch(err => {
				this.setState({
					isLoading: false,
					loading: true
				});

				console.log(err);
			});
		this.props.sharedActions
			.getDataWithoutDispatch('/api/campusDepartment')
			.then(success => {
				debugger;
				this.setState({
					campusAllData: success
				});
			})
			.catch(err => {
				this.setState({
					msg: 'No Record Found',
					isLoading: false
				});
				this.props.snackbar();
				console.log(err);
			});
	}
	btnTechHover = () => {
		$(document).ready(function() {
			$('button').hover(
				function() {
					$(this).css('box-shadow', '0px 5px 5px grey');
					$(this).css('border-color', 'white');
				},
				function() {
					$(this).css('box-shadow', '0px 0px 0px white');
				}
			);
		});
	};
	RemoveItem = itemId => {
		debugger;
		this.setState({
			adminData: [...this.state.adminData.filter(item => item.id != itemId)]
		});
		debugger;
	};
	onTakeItemDelete = itemId => {
		this.setState({
			modalData: []
		});
		this.props.sharedActions
			.deleteRecordWithoutDispatch('/api/Managers', itemId)
			.then(success => {
				this.setState({
					msg: 'Delete Record Successfully!'
				});
				this.RemoveItem(itemId);
				this.props.snackbar();
			})
			.catch(error => {});
	};
	onTakeItem = itemId => {
		// campusAddress:'',
		// campusName:'',
		// campusPhoneNumber:"",
		// campusCity:"",
		this.setState({
			modalData: []
		});
		const { adminData } = this.state;
		let getData = adminData.filter(item => item.id === itemId);

		this.setState({
			modalData: getData,
			name: getData[0].name,
			post: getData[0].post,
			userName: getData[0].userName,
			password: getData[0].password,
			staffId: getData[0].staffId,
			id: getData[0].id
		});
	};

	onHandleText = e => {
		this.setState({
			[e.target.name]: e.target.value
		});
	};
	Reload = () => {
		setTimeout(function() {
			window.location.reload();
		}, 3000);
	};
	onHandleSubmit = e => {
		e.preventDefault();
		const { id, name, userName, post, password, staffId } = this.state;
		var bodyParameters = {
			id,
			staffId,
			name,
			post,
			userName,
			password,
			accountId: this.props.users.unique_name,
			accountType: this.props.users.role
		};
		this.props.sharedActions
			.editRecordWithoutDispatch('/api/Managers/', id, bodyParameters)
			.then(success => {
				debugger;
				this.setState({ enabled: false, msg: 'Edit Record Successfully!' });
				this.props.snackbar();
				this.Reload();
			})
			.catch(err => {});
	};
	onEditClick = itemId => {
		this.onTakeItem(itemId);
		this.setState({ enabled: false });
	};

	onCampusChange = e => {
		const { campusAllData } = this.state;
		let Department = campusAllData.department.filter(
			item => item.campusId == e.target.value
		);
		this.setState({
			department: Department
		});
	};

	onDepartmentChange = e => {
		const { campusAllData } = this.state;
		let Staff = campusAllData.staff.filter(
			item => item.departmentId == e.target.value
		);
		this.setState({
			staff: Staff
		});
	};

	onPostChange = e => {
		const { campusAllData } = this.state;
		let result = JSON.parse(e.target.value);
		let Staff = campusAllData.staff.filter(
			item => item.postId == result.postId
		);
		this.setState({
			staff: Staff,
			post: result.postName
		});
	};

	onStaffChange = e => {
		let result = JSON.parse(e.target.value);
		this.setState({
			staffId: result.staffId,
			name: result.name
		});
	};
	render() {
		const { adminData, modalData } = this.state;
		const { department, postData, staff } = this.state;
		const { campus } = this.state.campusAllData;
		console.log('modal data: ', this.state.modalData);
		const Loader = (
			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<div class="spinner-border" style={{ color: '#01AC8A' }}></div>
			</div>
		);
		let pageNumbers = [];
		for (
			let i = 1;
			i <= Math.ceil(adminData.length / this.state.todosPerPage);
			i++
		) {
			pageNumbers.push(i);
		}
		const renderPageNumbers = pageNumbers.map((number, index) => {
			return index <= 3 ? (
				<li
					class={`page-item ${
						this.state.currentPage === number ? 'active' : ''
					} `}
				>
					<a
						key={number}
						id={number}
						onClick={this.handleClickNext}
						class="page-link "
						href="#"
					>
						{number}
					</a>
				</li>
			) : (
				''
			);
		});
		const { currentPage, todosPerPage } = this.state;
		const indexOfLastTodo = currentPage * todosPerPage;
		const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
		const currentTodos = adminData.slice(indexOfFirstTodo, indexOfLastTodo);
		const renderTodos = currentTodos.map((item, index) => {
			return (
				<tr key={index}>
					<th scope="row">{index + 1}</th>
					<td>{item.name}</td>
					<td>{item.password}</td>
					<td>{item.userName}</td>
					<td>{item.post}</td>
					<td>{item.date}</td>
					<td>{item.time}</td>
					<td>{item.accountId}</td>
					<td>{item.accountType}</td>
					<td>
						<a href="#" data-toggle="tooltip" title="Edit!">
							<button
								id="firstbutton"
								onClick={() => this.onEditClick(item.id)}
								onMouseOver={this.btnTechHover()}
								data-toggle="modal"
								data-target="#myModal"
								style={{
									cursor: 'pointer',
									fontSize: 20,
									border: 'none',
									marginLeft: 5,
									background: 'none',
									marginBottom: 5
								}}
							>
								<i class="fas fa-pen"></i>
							</button>
						</a>
						<a href="#" data-toggle="tooltip" title="Delete!">
							<button
								onClick={() => this.onEditClick(item.id)}
								data-toggle="modal"
								data-target="#myModal1"
								style={{
									cursor: 'pointer',
									fontSize: 20,
									border: 'none',
									background: 'none',
									marginLeft: 5,
									marginBottom: 5
								}}
							>
								<i style={{ color: '#D11A2A' }} class="fas fa-trash-alt"></i>
							</button>
						</a>
					</td>
				</tr>
			);
		});
		const MainContent = (
			<div>
				<div class="modal" id="myModal1">
					<div class="modal-dialog">
						<div class="modal-content modal_content_custom">
							<div
								style={{
									borderBottomLeftRadius: 30,
									borderBottomRightRadius: 30,
									borderTopLeftRadius: 18,
									borderTopRightRadius: 18
								}}
								class="modal-header modal_custom_header"
							>
								<h4 style={{ color: 'white' }} class="modal-title">
									Confirm
								</h4>
								<button
									style={{ color: 'white' }}
									type="button"
									class="close"
									data-dismiss="modal"
								>
									&times;
								</button>
							</div>
							<div class="modal-body">
								{modalData &&
									modalData.map((item, index) => (
										<div key={index}>
											<div style={{ textAlign: 'center' }}>
												<h4>Are you sure ?</h4>
											</div>
											<div
												style={{
													display: 'flex',
													justifyContent: 'space-evenly'
												}}
											>
												<div>
													<button
														disabled={this.state.enabled}
														data-dismiss="modal"
														onClick={() => this.onTakeItemDelete(this.state.id)}
														type="button"
														class="btn btn-primary buttonAppear"
													>
														Yes
													</button>
												</div>
												<div>
													<button
														data-dismiss="modal"
														disabled={this.state.enabled}
														type="button"
														class="btn btn-primary buttonAppear"
													>
														No
													</button>
												</div>
											</div>
										</div>
									))}
							</div>
						</div>
					</div>
				</div>

				<div class="modal" id="myModal">
					<div class="modal-dialog">
						<div class="modal-content modal_content_custom">
							<div
								style={{
									borderBottomLeftRadius: 30,
									borderBottomRightRadius: 30,
									borderTopLeftRadius: 18,
									borderTopRightRadius: 18
								}}
								class="modal-header modal_custom_header"
							>
								<h4 style={{ color: 'white' }} class="modal-title">
									Details
								</h4>
								<button
									style={{ color: 'white' }}
									type="button"
									class="close"
									data-dismiss="modal"
								>
									&times;
								</button>
							</div>
							<div class="modal-body">
								<form onSubmit={this.onHandleSubmit}>
									{modalData &&
										modalData.map((item, index) => (
											<div key={index}>
												<fieldset disabled={!this.state.enabled}>
													<div class="form-group">
														<div class="col-md-12" style={{ marginTop: 20 }}>
															<div class="md-form mb-0">
																<label for="email" class="">
																	Campus
																</label>
																<select
																	onChange={this.onCampusChange}
																	class="custom-select"
																	name="campusId"
																>
																	<option
																		selected={this.state.msg ? true : false}
																	>
																		Select Campus...
																	</option>
																	{campus &&
																		campus.map((item, index) => (
																			<option
																				key={index}
																				value={`${item.campusId}`}
																			>
																				{item.campusName}
																			</option>
																		))}
																</select>
															</div>
														</div>
													</div>
													<div class="form-group">
														<div class="col-md-12" style={{ marginTop: 20 }}>
															<div class="md-form mb-0">
																<label for="email" class="">
																	Department
																</label>
																<select
																	onChange={this.onDepartmentChange}
																	class="custom-select"
																	name="campusId"
																>
																	<option
																		selected={this.state.msg ? true : false}
																	>
																		Select Department...
																	</option>
																	{department.map((item, index) => (
																		<option
																			key={index}
																			value={`${item.departmentId}`}
																		>
																			{item.departmentName}
																		</option>
																	))}
																</select>
															</div>
														</div>
													</div>
													<div class="form-group">
														<div class="col-md-12" style={{ marginTop: 20 }}>
															<div class="md-form mb-0">
																<label for="name" class="font-weight-bold">
																	Post
																</label>
																<select
																	onChange={this.onHandleText}
																	class="custom-select"
																	name="post"
																>
																	<option
																		selected={this.state.click ? true : false}
																	>
																		Choose Post..
																	</option>
																	<option value="Agent Manager">
																		Agent Manager
																	</option>
																	<option value="Admission Manager">
																		Admission Manager
																	</option>
																	<option value="Accountant">Accountant</option>
																	<option value="Billing Accountant">
																		Billing Accountant
																	</option>
																</select>
															</div>
														</div>
													</div>
													<div class="form-group">
														<div class="col-md-12" style={{ marginTop: 20 }}>
															<div class="md-form mb-0">
																<label for="email" class="">
																	Staff
																</label>
																<select
																	onChange={this.onStaffChange}
																	class="custom-select"
																	name="name"
																>
																	<option
																		selected={this.state.msg ? true : false}
																	>
																		Select Staff...
																	</option>
																	{staff.map((item, index) => (
																		<option
																			key={index}
																			value={`${JSON.stringify(item)}`}
																		>
																			{item.name}
																		</option>
																	))}
																</select>
															</div>
														</div>
													</div>
													<div class="form-group">
														<label for="pwd">Post:</label>

														<input
															readOnly={true}
															required
															style={{
																borderTop: 0,
																borderLeft: 0,
																borderRight: 0,
																boxShadow: 'none'
															}}
															value={this.state.post}
															onChange={this.onHandleText}
															type="text"
															name="post"
															class="form-control"
															id="post"
														/>
													</div>
													<div class="form-group">
														<label for="username">Username:</label>
														<input
															style={{
																borderTop: 0,
																borderLeft: 0,
																borderRight: 0,
																boxShadow: 'none'
															}}
															readOnly={true}
															type="text"
															value={this.state.userName}
															onChange={this.onHandleText}
															name="username"
															class="form-control"
															id="username"
														/>
													</div>
													<div class="form-group">
														<label for="username">Name:</label>
														<input
															style={{
																borderTop: 0,
																borderLeft: 0,
																borderRight: 0,
																boxShadow: 'none'
															}}
															readOnly={true}
															type="text"
															value={this.state.name}
															onChange={this.onHandleText}
															name="name"
															class="form-control"
															id="name"
														/>
													</div>
													<div class="form-group">
														<label for="pwd">Password:</label>
														<input
															required
															style={{
																borderTop: 0,
																borderLeft: 0,
																borderRight: 0,
																boxShadow: 'none'
															}}
															value={this.state.password}
															onChange={this.onHandleText}
															type="password"
															name="password"
															class="form-control"
															id="password"
														/>
													</div>
												</fieldset>
												<button
													disabled={this.state.enabled}
													onClick={() => this.setState({ enabled: true })}
													type="button"
													class="btn btn-primary buttonAppear"
												>
													Edit
												</button>
												<button
													style={{ marginLeft: 5 }}
													disabled={!this.state.enabled}
													type="submit"
													class="btn btn-primary buttonAppear"
												>
													Save
												</button>
											</div>
										))}
								</form>
							</div>
							<div class="modal-footer">
								<button
									type="button"
									style={{ background: '#00435D' }}
									class="btn btn-danger"
									data-dismiss="modal"
								>
									Close
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <div className='table-responsive' > */}
				<table
					class="table table-hover table-bordered"
					style={{ textAlign: 'center' }}
				>
					<thead style={{ background: '#01AC8A', color: 'white' }}>
						<tr>
							<th scope="col">#</th>
							<th scope="col">Name</th>
							<th scope="col">Password</th>
							<th scope="col">User Name</th>
							<th scope="col">Post</th>
							<th scope="col">Date</th>
							<th scope="col">Time</th>
							<th scope="col">AccountId</th>
							<th scope="col">AccountType</th>
							<th scope="col">Actions</th>
						</tr>
					</thead>
					<tbody>{renderTodos}</tbody>
				</table>
			</div>
			// </div>
		);
		return (
			<div>
				<div className="page-header">
					<SnackBar msg={this.state.msg} />
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}
					>
						<div>
							<h2>Manager's Detail</h2>
						</div>
						<nav aria-label="Page navigation example">
							<ul style={{ color: '#01AC8A' }} class="pagination">
								<li
									class={`page-item ${
										this.state.disableBPage ? 'disabled' : ''
									}`}
								>
									<a
										onClick={this.handleClickNextBack}
										class="page-link"
										href="#"
									>
										{this.state.disableBPage ? (
											<i
												style={{ color: 'grey' }}
												class="far fa-stop-circle"
											></i>
										) : (
											<i class="fas fa-backward"></i>
										)}
									</a>
								</li>
								{renderPageNumbers}
								<li
									class={`page-item ${
										this.state.disablepage ? 'disabled' : ''
									}`}
								>
									<a
										onClick={this.handleClickNextFrwd}
										class="page-link"
										href="#"
									>
										{this.state.disablepage ? (
											<i
												style={{ color: 'grey' }}
												class="far fa-stop-circle"
											></i>
										) : (
											<i class="fas fa-forward"></i>
										)}
									</a>
								</li>
							</ul>
						</nav>
					</div>
				</div>
				{this.state.loading ? Loader : MainContent}
			</div>
		);
	}
}
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(getAllAdminActions, dispatch),
		campusActions: bindActionCreators(CampusActions, dispatch),
		sharedActions: bindActionCreators(sharedActions, dispatch)
	};
}
function mapStateToProps(state) {
	return {
		users: state.setUserReducer.users
	};
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ViewManager);
